import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-plus position-relative ms-5 fs-12" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}, " ID ", -1 /* HOISTED */)
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "linked" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_25 = { class: "dropdown position-static" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("button", {
  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-boundary": "viewport"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" })
], -1 /* HOISTED */)
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-eye lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-8 position-relative top-1" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_TablePagination = _resolveComponent("TablePagination")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/create-center",
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('cta.create_center')) + " ", 1 /* TEXT */),
                  _hoisted_4
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.centers === undefined)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_8,
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('form.name.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('form.country.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('form.address.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('form.main_contractor.label')), 1 /* TEXT */),
                    _hoisted_15
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_16, [
                  _createCommentVNode(" CENTER ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centers, (center) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'tr_center_' + center.id
                    }, [
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-primary",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.id), 9 /* TEXT, PROPS */, _hoisted_17),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-black-emphasis",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.name), 9 /* TEXT, PROPS */, _hoisted_18),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.country), 9 /* TEXT, PROPS */, _hoisted_19),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.address), 9 /* TEXT, PROPS */, _hoisted_20),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.email), 9 /* TEXT, PROPS */, _hoisted_21),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.phone), 9 /* TEXT, PROPS */, _hoisted_22),
                      _createElementVNode("td", {
                        class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0",
                        onClick: ($event: any) => (_ctx.show(center))
                      }, _toDisplayString(center.main_contractor), 9 /* TEXT, PROPS */, _hoisted_23),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("ul", _hoisted_27, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_router_link, {
                                to: { path: `/center/${center.id}` },
                                class: "dropdown-item d-flex align-items-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.view')), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                            ]),
                            (_ctx.isAdmin)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                  _createVNode(_component_router_link, {
                                    to: { path: `/center/${center.id}/edit` },
                                    class: "dropdown-item d-flex align-items-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_30,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                ]))
                              : _createCommentVNode("v-if", true),
                            (_ctx.isAdmin)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                  _createElementVNode("button", {
                                    class: "dropdown-item d-flex align-items-center",
                                    onClick: ($event: any) => (_ctx.confirmDeleteCenter(center))
                                  }, [
                                    _hoisted_33,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.delete')), 1 /* TEXT */)
                                  ], 8 /* PROPS */, _hoisted_32)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])),
        _createCommentVNode(" PAGINATION "),
        _createVNode(_component_TablePagination, {
          count: _ctx.centers?.length ?? 0,
          page: _ctx.currentPage,
          total: _ctx.total,
          pages: _ctx.lastPage,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPage($event)))
        }, null, 8 /* PROPS */, ["count", "page", "total", "pages"])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteCenter())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}